import { createAction, props } from "@ngrx/store";

const pI = "[PLAN_MOBILE] ";
export const setBaseMobilePlan = createAction("[PLAN_MOBILE] SET_MOBILE_BASE_PLAN", props<{ planIdentifier: string }>());
export const setSelectedBaseMobilePlan = createAction("[PLAN_MOBILE] SET_SELECTED_MOBILE_BASE_PLAN", props<{ plan: any }>());
export const setAddonsMobilePlan = createAction("[PLAN_MOBILE] SET_ADDONS_MOBILE_PLAN", props<{ addons: string[] }>());
export const setProductOfferingMobilePlan = createAction(`${pI} SET_PLAN_PRODUCT_OFFERING`, props<{ productOffering: any }>());
export const setQuoteMobilePlan = createAction(`${pI} SET_QUOTE`, props<{ quote: any }>());
